import { ActionType } from './model'

export const getProfileAction = () => ({
  type: ActionType.GET_PROFILE,
})
